import { LayoutContainer, Section } from '@petsmart-ui/sparky';
import StandardTile from './StandardTile';
import type { StandardTilesProps } from '../types';

export default function StandardTiles({ title, tiles }: StandardTilesProps) {
    return (
        <LayoutContainer className="tiles4-container" data-testid="tiles4-standard">
            <Section title={title}>
                <div className="tiles-4">
                    {tiles.map(item => (
                        <StandardTile {...item} key={item.sysId} />
                    ))}
                </div>
            </Section>
        </LayoutContainer>
    );
}
